import { Injectable } from '@angular/core';
import API from '../../common/services/api.config.json';
import { HttpClient } from '@angular/common/http';
import { constant } from 'app/modules/common/helpers/constant';
import {
    BehaviorSubject,
    Observable,
    Subscription,
    pipe,
    of,
    from,
} from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
@Injectable({providedIn:'root'})
export class DireccionService {
    provinces: Array<string> = [];
    cities: Array<any> = [];
    cities2: Array<any> = [];

    public ProvinceList: Array<{ value: string; viewValue: string }>;

    constructor(private http: HttpClient) {
        this.GetHardCodedList();
    }

    getAllProvince(): Observable<RestResponse> {
        if (this.provinces.length === 0) {
            let url: string = `${constant.HOME_URL}${API.Direccion.getAllProvince}`;
            return this.http.get<RestResponse>(url).pipe(
                tap((resp) => {
                    this.provinces = [];
                    resp.result.map((elem) => {
                        this.provinces.push(elem);
                    });
                    this.provinces.sort();
                })
            );
        }
        return of(null);
    }

    getProvinceCities(province: string): Observable<RestResponse> {
        if (!province) {
            this.cities = [];
            return of(null);
        }

        let url: string = `${constant.HOME_URL}${API.Direccion.getProvinceCities}`;
        url = url.replace('{province}', province);
        return this.http.get<RestResponse>(url).pipe(
            tap((resp) => {
                this.cities = [];
                resp.result.map((elem) => {
                    this.cities.push(elem);
                });
                this.cities.sort(function (a, b) {
                    if (a.nombre < b.nombre) {
                        return -1;
                    } else if (a.nombre > b.nombre) {
                        return 1;
                    }
                    return 0;
                });
            })
        );
    }

    getProvince2Cities(province: string): Observable<RestResponse> {
        let url: string = `${constant.HOME_URL}${API.Direccion.getProvinceCities}`;
        url = url.replace('{province}', province);
        return this.http.get<RestResponse>(url).pipe(
            tap((resp) => {
                this.cities2 = [];
                resp.result.map((elem) => {
                    this.cities2.push(elem);
                });
                this.cities2.sort(function (a, b) {
                    if (a.nombre < b.nombre) {
                        return -1;
                    } else if (a.nombre > b.nombre) {
                        return 1;
                    }
                    return 0;
                });
            })
        );
    }

    validateAddressByCp(postalCode: string): Observable<RestResponse> {
        let url: string = `${constant.HOME_URL}${API.Direccion.validateAddressByCp}`;
        url = url.replace('{postalCode}', postalCode);
        return this.http.get<RestResponse>(url);
    }

    GetHardCodedList() {
        this.ProvinceList = [
            { value: 'ALAVA', viewValue: 'ALAVA' },
            { value: 'ALBACETE', viewValue: 'ALBACETE' },
            { value: 'ALICANTE', viewValue: 'ALICANTE' },
            { value: 'ALMERIA', viewValue: 'ALMERIA' },
            { value: 'ANDORRA', viewValue: 'ANDORRA' },
            { value: 'ASTURIAS', viewValue: 'ASTURIAS' },
            { value: 'AVILA', viewValue: 'AVILA' },
            { value: 'BADAJOZ', viewValue: 'BADAJOZ' },
            { value: 'BALEARES', viewValue: 'BALEARES' },
            { value: 'BARCELONA', viewValue: 'BARCELONA' },
            { value: 'BURGOS', viewValue: 'BURGOS' },
            { value: 'CACERES', viewValue: 'CACERES' },
            { value: 'CADIZ', viewValue: 'CADIZ' },
            { value: 'CANTABRIA', viewValue: 'CANTABRIA' },
            { value: 'CASTELLON', viewValue: 'CASTELLON' },
            { value: 'CEUTA', viewValue: 'CEUTA' },
            { value: 'CIUDAD REAL', viewValue: 'CIUDAD REAL' },
            { value: 'CORDOBA', viewValue: 'CORDOBA' },
            { value: 'CUENCA', viewValue: 'CUENCA' },
            { value: 'GIRONA', viewValue: 'GIRONA' },
            { value: 'GRANADA', viewValue: 'GRANADA' },
            { value: 'GUADALAJARA', viewValue: 'GUADALAJARA' },
            { value: 'GUIPUZCOA', viewValue: 'GUIPUZCOA' },
            { value: 'HUELVA', viewValue: 'HUELVA' },
            { value: 'HUESCA', viewValue: 'HUESCA' },
            { value: 'JAEN', viewValue: 'JAEN' },
            { value: 'LA CORUÑA', viewValue: 'LA CORUÑA' },
            { value: 'LAS RIOJA', viewValue: 'LAS RIOJA' },
            { value: 'LAS PALMAS', viewValue: 'LAS PALMAS' },
            { value: 'LEON', viewValue: 'LEON' },
            { value: 'LLEIDA', viewValue: 'LLEIDA' },
            { value: 'LUGO', viewValue: 'LUGO' },
            { value: 'MADRID', viewValue: 'MADRID' },
            { value: 'MALAGA', viewValue: 'MALAGA' },
            { value: 'MELILLA', viewValue: 'MELILLA' },
            { value: 'MURCIA', viewValue: 'MURCIA' },
            { value: 'NAVARRA', viewValue: 'NAVARRA' },
            { value: 'ORENSE', viewValue: 'ORENSE' },
            { value: 'PALENCIA', viewValue: 'PALENCIA' },
            { value: 'PONTEVEDRA', viewValue: 'PONTEVEDRA' },
            { value: 'SALAMANCA', viewValue: 'SALAMANCA' },
            {
                value: 'SANTA CRUZ DE TENERIFE',
                viewValue: 'SANTA CRUZ DE TENERIFE',
            },
            { value: 'SEGOVIA', viewValue: 'SEGOVIA' },
            { value: 'SEVILLA', viewValue: 'SEVILLA' },
            { value: 'SORIA', viewValue: 'SORIA' },
            { value: 'TARRAGONA', viewValue: 'TARRAGONA' },
            { value: 'TERUEL', viewValue: 'TERUEL' },
            { value: 'TOLEDO', viewValue: 'TOLEDO' },
            { value: 'VALENCIA', viewValue: 'VALENCIA' },
            { value: 'VALLADOLID', viewValue: 'VALLADOLID' },
            { value: 'VIZCAYA', viewValue: 'VIZCAYA' },
            { value: 'ZAMORA', viewValue: 'ZAMORA' },
            { value: 'ZARAGOZA', viewValue: 'ZARAGOZA' },
        ];
    }
}
